import React, { useState } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    service: '',
    message: '',
  });
  const [loading, setLoading] = useState(false);
  const EmailURL = 'https://api.brevo.com/v3/smtp/email';

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  async function sendEmail(e) {
    e.preventDefault();
    try {
      setLoading(true);
      // Validate that a service was selected
      if (!formData.name || !formData.email || !formData.phone || !formData.message || !formData.service) {
        toast.info('Please fill all fields and select a service');
        setLoading(false);
        return;
      }

      const response = await axios.post(EmailURL, {
        sender: {
          name: formData.name,
          email: formData.email,
        },
        to: [
          {
            email: 'helloqoncave@gmail.com',
            name: "Qoncave",
          },
        ],
        subject: `NEW INQUIRY: ${formData.service}`, // Subject now shows the service
        htmlContent: `
          <html>
            <body>
              <h3>New Service Inquiry: ${formData.service}</h3>
              <p><strong>Customer Name:</strong> ${formData.name}</p>
              <p><strong>Service Requested:</strong> ${formData.service}</p>
              <p><strong>Phone:</strong> ${formData.phone}</p>
              <p><strong>Message:</strong></p>
              <p>${formData.message}</p>
            </body>
          </html>`,
      }, {
        headers: {
          accept: 'application/json',
          'api-key': process.env.REACT_APP_EMAIL_API_KEY,
          'content-type': 'application/json',
        },
      });

      if (response.status === 201 || response.status === 200) {
        toast.success('Email sent successfully!');
        setFormData({ name: '', email: '', phone: '', service: '', message: '' });
      }
    } catch (error) {
      toast.error('Error sending email');
      console.error(error);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="font-Poppins max-w-7xl mx-auto p-4 lg:py-36 text-slate-950 dark:text-gray-100">
      {/* Loading Spinner */}
      {loading && (
        <div className="fixed inset-0 flex justify-center items-center bg-gray-500 bg-opacity-50 z-50 dark:bg-slate-900 dark:bg-opacity-50">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-orange-500"></div>
        </div>
      )}

      <h1 className="text-3xl font-bold text-center mb-6">Contact Us</h1>
      <div className="w-full flex justify-center mb-2 items-center">
        <div className="h-1.5 w-36 bg-orange-500 mb-3 mt-3 rounded-lg"></div>
      </div>

      <form onSubmit={sendEmail} className="space-y-6 max-w-4xl mx-auto">
        {/* Top Row: Personal Info */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Your Name"
            className="p-3 border border-gray-400 rounded-md w-full focus:outline-none focus:ring-2 focus:ring-orange-500"
          />
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Your Email"
            className="p-3 border border-gray-400 rounded-md w-full focus:outline-none focus:ring-2 focus:ring-orange-500"
          />
          <input
            type="tel"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            placeholder="Your Phone Number"
            className="p-3 border border-gray-400 rounded-md w-full focus:outline-none focus:ring-2 focus:ring-orange-500"
          />
        </div>

        {/* New Service Dropdown */}
        <div className="w-full">
          <select
            name="service"
            value={formData.service}
            onChange={handleChange}
            className="p-3 border border-gray-400 rounded-md w-full bg-white text-slate-950 focus:outline-none focus:ring-2 focus:ring-orange-500 dark:bg-slate-900 dark:text-gray-100 dark:border-slate-700"
          >
            <option value="" disabled>Select a Service</option>
            <option value="Gypsum Plaster Board">Gypsum Plaster Board</option>
            <option value="Concrete Designs">Concrete Designs</option>
            <option value="POP Casting Designs and Installations">POP Casting Designs and Installations</option>
            <option value="Dry Wall Partitioning">Dry Wall Partitioning</option>
            <option value="Screeding, Consoles and Wall Finishes">Screeding, Consoles and Wall Finishes</option>
          </select>
        </div>

        <div className="w-full">
          <textarea
            name="message"
            value={formData.message}
            onChange={handleChange}
            placeholder="Your Message"
            className="p-3 border border-gray-400 rounded-md w-full h-40 bg-white text-slate-950 focus:outline-none focus:ring-2 focus:ring-orange-500 dark:bg-slate-900 dark:text-gray-100 dark:border-slate-700"
          />
        </div>

        {/* Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <button
            type="submit"
            className="w-full sm:w-1/2 p-3 bg-orange-500 text-white text-[20px] font-bold rounded-lg hover:bg-orange-600 transition-colors"
          >
            Mail Us
          </button>

          <a
            href="tel:+2348131591112" 
            className="w-full sm:w-1/2 p-3 bg-blue-500 text-white text-[20px] font-bold rounded-lg hover:bg-blue-600 transition-colors text-center"
          >
            Call Us
          </a>
        </div>
      </form>
    </div>
  );
};

const Contact = () => (
  <>
    <ContactPage />
    <ToastContainer position="bottom-right" />
  </>
);

export default Contact;